/**
 * The one sentence a browser that cannot play the recording says, wherever a control is inert
 * because of it.
 *
 * Its own component because two surfaces show it — the footer's play button and every per-turn
 * glyph — and a disabled control swallows the pointer along with the tooltip it would open, so the
 * wrapper is what takes the hover. Where nothing is wrong it renders its child and nothing else,
 * so no surface has to branch on whether to wrap.
 */

import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { PLAYBACK_UNSUPPORTED_FORMAT_MESSAGE } from "../lib/transcript-playback";

export function PlaybackUnsupportedTooltip({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  if (!enabled) return children;
  return (
    <Tooltip>
      <TooltipTrigger render={<span className="inline-flex shrink-0" />}>{children}</TooltipTrigger>
      <TooltipContent data-testid="transcript-playback-unsupported">
        {PLAYBACK_UNSUPPORTED_FORMAT_MESSAGE}
      </TooltipContent>
    </Tooltip>
  );
}
